import { Grid } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const TileContent: FC<Props> = ({ children }) => {
  return (
    <Grid container rowSpacing={1} columnSpacing={1}>
      {children}
    </Grid>
  );
};

export default TileContent;
